import { render, staticRenderFns } from "./WorkflowTestTaskForm.vue?vue&type=template&id=935b2440"
import script from "./WorkflowTestTaskForm.vue?vue&type=script&lang=js"
export * from "./WorkflowTestTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports